import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './Navbar';
import Intro from './Intro';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import Contact from './Contact';
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>

function App() {
return (
    <div className="Body">
           <NavBar/>
           <Intro/>
        <div className="about">
           <About/>
        </div>
        <div className="skills">
           <Skills/>
        </div>
        <div className="projects">
            <Projects/>
        </div>
        <div className="contact">
            <Contact/>
        </div>
    </div>
  );
}

export default App;
